export const NORTH_AMERICA_CODES = [
  "AG",
  "BB",
  "BM",
  "BS",
  "BZ",
  "CA",
  "CR",
  "CU",
  "DM",
  "DO",
  "GD",
  "GP",
  "GT",
  "HN",
  "HT",
  "JM",
  "KN",
  "KY",
  "LC",
  "MF",
  "MQ",
  "MS",
  "MX",
  "NI",
  "PA",
  "PM",
  "PR",
  "SV",
  "SX",
  "TC",
  "TT",
  "US",
  "US-main",
  "VG",
  "VI",
];
